export default __webpack_public_path__ + "assets/ticketbutler_logo-d8ba66fd84b0948af843ed08b8a776e4.png";